import {
  // environmentModel,
  valueModel,
  executionModel,
  // governanceModel,
  peopleModel,
  strategyModel,
  enterpriseModel,
  strategyValueModel,
  enterpriseIntegrationConsiderationsModel,
  organizationPeopleModel,
} from './quesModels';

export const QUES_SECTIONS_KEYS = {
  // Value: 'value',
  // Environment: 'environment',
  // Governance: 'governance',
  // People: 'people',
  // Execution: 'execution',
  // Strategy: 'strategy',
  // Enterprise: 'enterprise',

  // new section
  StrategyValue: 'strategy & value creation',
  OrganizationPeople: 'organization & people',
  EnterpriseIntegrationConsiderations:
    'enterprise & integration considerations',
};

export const QUES_SECTIONS_SEQ = [
  QUES_SECTIONS_KEYS.StrategyValue,
  QUES_SECTIONS_KEYS.OrganizationPeople,
  QUES_SECTIONS_KEYS.EnterpriseIntegrationConsiderations,

  // old section
  // QUES_SECTIONS_KEYS.Strategy,
  // QUES_SECTIONS_KEYS.Value,
  // QUES_SECTIONS_KEYS.Enterprise,
  // // QUES_SECTIONS_KEYS.Environment,
  // // QUES_SECTIONS_KEYS.Governance,
  // QUES_SECTIONS_KEYS.People,
  // QUES_SECTIONS_KEYS.Execution,
];

export const QUES_SECTIONS_DESCRIPTION = {
  [QUES_SECTIONS_KEYS.StrategyValue]: {
    title: 'Strategy & Value Creation',
    desc: 'Complexity based on deal intent, deal type, expected degree of integration or disentanglement, level of upfront diligence performed, and deal model expectations of cost and revenue synergies.',
  },
  [QUES_SECTIONS_KEYS.OrganizationPeople]: {
    title: 'Organization & People',
    desc: 'Complexity based on change management considerations, leadership decisions, organization structure, geographic locations and total rewards harmonization.',
  },
  [QUES_SECTIONS_KEYS.EnterpriseIntegrationConsiderations]: {
    title: 'Enterprise & Integration Considerations',
    desc: 'Complexities based on changes to the operating model of NewCo/RemainCo as a result of the deal (e.g., front and back-office changes, legal entity restructuring), degree of integration application rationalization opportunities, and other in-flight projects that will contend for resources, and overall capability and capacity.',
  },

  // old section
  [QUES_SECTIONS_KEYS.Strategy]: {
    title: 'Strategy',
    desc: 'Complexity based on deal intent, deal type, expected degree of integration or disentanglement, and level of upfront diligence performed',
  },
  [QUES_SECTIONS_KEYS.Value]: {
    title: 'Value',
    desc: 'Complexities based on deal model expectations of cost and revenue synergies',
  },
  [QUES_SECTIONS_KEYS.Enterprise]: {
    title: 'Enterprise',
    desc: 'Complexities based on changes to the operating model of NewCo/RemainCo as a result of the deal, including front and back-office changes, as well as legal entity restructuring requirement',
  },
  [QUES_SECTIONS_KEYS.Environment]: {
    title: 'Environment',
    desc: 'Understand complexities related to industry(ies), regulatory approvals, marco economic trends, and geographic overlap across Buyer and Target profiles.',
  },
  [QUES_SECTIONS_KEYS.Governance]: {
    title: 'Governance',
    desc: 'Understand deal type, expected degree of integration, and planning resources committed to the deal to determine integration complexity.',
  },
  [QUES_SECTIONS_KEYS.People]: {
    title: 'People',
    desc: 'Complexity based on change management considerations, leadershp decisions, geographic locations and benefit harmonization',
  },
  [QUES_SECTIONS_KEYS.Execution]: {
    title: 'Execution',
    desc: 'Complexity based on degree of integration application rationalization opportunities, other in-flight projects that will contend for resources, and overall capability and capacity',
  },
};

export const quesModel = {
  [QUES_SECTIONS_KEYS.StrategyValue]: strategyValueModel,
  [QUES_SECTIONS_KEYS.OrganizationPeople]: organizationPeopleModel,
  [QUES_SECTIONS_KEYS.EnterpriseIntegrationConsiderations]:
    enterpriseIntegrationConsiderationsModel,

  // old section
  // [QUES_SECTIONS_KEYS.Strategy]: strategyModel,
  // [QUES_SECTIONS_KEYS.Value]: valueModel,
  // [QUES_SECTIONS_KEYS.Enterprise]: enterpriseModel,
  // [QUES_SECTIONS_KEYS.Environment]: environmentModel,
  // [QUES_SECTIONS_KEYS.Governance]: governanceModel,
  // [QUES_SECTIONS_KEYS.People]: peopleModel,
  // [QUES_SECTIONS_KEYS.Execution]: executionModel,
};

export const quesModel_FLAT = [
  ...quesModel[QUES_SECTIONS_KEYS.StrategyValue],
  ...quesModel[QUES_SECTIONS_KEYS.OrganizationPeople],
  ...quesModel[QUES_SECTIONS_KEYS.EnterpriseIntegrationConsiderations],
  // old section
  // ...quesModel[QUES_SECTIONS_KEYS.Strategy],
  // ...quesModel[QUES_SECTIONS_KEYS.Value],
  // ...quesModel[QUES_SECTIONS_KEYS.Enterprise],
  // ...quesModel[QUES_SECTIONS_KEYS.People],
  // ...quesModel[QUES_SECTIONS_KEYS.Execution],
];

export const SECTIONS_LENGTH = QUES_SECTIONS_SEQ.map(
  (k) => quesModel[k].length,
);

export const QUES_STATUS = ['unread', 'draft', 'finish', 'notApplicable'];
export const QUESTION_STATUS = {
  Unread: 0,
  Draft: 1,
  Finish: 2,
  NotApplicable: 3,
};

export const defaultQuesStepStatus = {
  status: QUES_STATUS[0],
};

export const COMPLEXITY_LEVEL_INDEX_MAP = {
  low: 1,
  medium: 2,
  high: 3,
};

export const percentToLevel = (percent) => {
  if (!percent && percent !== 0) {
    return undefined;
  }
  const halfThree = 100 / 3;
  if (percent <= halfThree) {
    return COMPLEXITY_LEVEL_INDEX_MAP.low;
  }
  if (percent > halfThree && percent <= halfThree * 2) {
    return COMPLEXITY_LEVEL_INDEX_MAP.medium;
  }
  return COMPLEXITY_LEVEL_INDEX_MAP.high;
};

export const COMPLEXITY_LEVEL_MAP = [null, 'low', 'medium', 'high'];
